import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// "MASTERS" -> "Masters"; identifiers such as master names (digits, underscores) are left as is.
const readable = (text) =>
    text === text.toUpperCase() && !/[\d_]/.test(text)
        ? text.charAt(0) + text.slice(1).toLowerCase()
        : text;

// Pages whose heading is the brand rather than their purpose
const FIXED_TITLES = { '/login': 'Connexion', '/register': 'Inscription' };

// On every route change: names the browser tab after the page's h1, announces the new page to
// screen readers, and moves focus to that heading when the clicked link has disappeared with the
// old page (otherwise focus would fall back to the top of the document).
export function RouteAnnouncer() {
    const { pathname } = useLocation();
    const [message, setMessage] = useState('');
    const isFirstLoad = useRef(true);

    useEffect(() => {
        let attempts = 0;
        let timer;
        const apply = () => {
            const heading = document.querySelector('h1');
            // Detail pages render their heading once data has loaded: wait up to ~2 s
            if (!heading && attempts++ < 20) {
                timer = setTimeout(apply, 100);
                return;
            }
            const name = FIXED_TITLES[pathname] || (heading ? readable(heading.textContent.trim()) : '');
            document.title = name ? `${name} — AD-Master` : 'AD-Master';
            if (isFirstLoad.current) {
                isFirstLoad.current = false;
                return;
            }
            setMessage(name);
            const active = document.activeElement;
            if (heading && (!active || active === document.body || !document.body.contains(active))) {
                heading.setAttribute('tabindex', '-1');
                heading.style.outline = 'none';
                heading.focus({ preventScroll: true });
            }
        };
        timer = setTimeout(apply, 0);
        return () => clearTimeout(timer);
    }, [pathname]);

    return (
        <div aria-live="polite" aria-atomic="true" className="sr-only">
            {message}
        </div>
    );
}
